import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=cbecdf58&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=cbecdf58&prod&lang=scss&scoped=true"
import style1 from "./privacy.vue?vue&type=style&index=1&id=cbecdf58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbecdf58",
  null
  
)

export default component.exports